var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.text),expression:"text"}],staticClass:"markdown__marked-text"})
}
var staticRenderFns = []

export { render, staticRenderFns }